<template>
  <div class="magnifier-container">
    <div class="magnifier-text" @click="magnified = !magnified">
      {{magnified ? magnificationText : unmagnifiedText}}
    </div>
    <img :src="processURL('_400x240_crop_center')" width="100%"  v-if="!magnified"/>
    <img class="magnified" :src="processURL('_600x360_crop_center')" width="100%"  v-else/>
  </div>
</template>
<script>
export default {
  name: "ImageMagnifier",
  props: {
    image: String,
  },
  data: function () {
    return {
      unmagnifiedText: "1x",
      magnificationText: "3x",
      magnified: false
    };
  },
  methods: {
    processURL(processingString) {
      let fileExtension = ".JPG";
      if (this.image.match(/(.jpg)/)) {
        fileExtension = ".jpg";
      }
      return this.image.replace(
        /(.jpg)/i,
        `${processingString}${fileExtension}`
      );
    },
  },
};
</script>
<style scoped>
.magnifier-container {
  position: relative;
}
.magnifier-container img {
  max-height: 246px;
}
.magnifier-text {
  background: #F0F0F0;
  border: 0.8px solid #393534;
  border-radius: 74px;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 8px;
  right: 6px;
  height: 31px;
  width: 31px;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}
.magnified {
  object-fit: none;
}
</style>
